"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../../constants/spacing"));

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var ImageContainer = _styledComponents.default.div(_templateObject(), function (props) {
  return props.density === 'expanded' && "padding: " + _spacing.default.s1 + " " + _spacing.default.s2 + " " + _spacing.default.s1 + " 0;";
});

ImageContainer.displayName = 'ImageContainer';

var IconContainer = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.density !== 'expanded' && "margin: 0 " + _spacing.default.s1 + " 0 -4px;";
});

IconContainer.displayName = 'IconContainer';

var OptionImage = function OptionImage(_ref) {
  var Icon = _ref.Icon,
      image = _ref.image,
      density = _ref.density;

  if (image) {
    return _react.default.createElement(ImageContainer, {
      density: density
    }, image);
  }

  if (Icon) {
    return _react.default.createElement(IconContainer, null, _react.default.createElement(Icon, {
      size: density === 'expanded' ? 24 : 20,
      role: "img"
    }));
  }

  return null;
};

OptionImage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  Icon: _propTypes.any,
  image: (0, _propTypes.oneOfType)([_propTypes.node, (0, _propTypes.arrayOf)(_propTypes.node)]),
  density: (0, _propTypes.oneOf)(['default', 'expanded'])
};
OptionImage.defaultProps = {
  Icon: undefined,
  image: undefined,
  density: 'default'
};
var _default = OptionImage;
exports.default = _default;